<template>
  <el-card shadow="never" :style="{ height: inputHeight + 'px' }" class="input-menu">
    <div slot="header">
      <span>{{ inputForm.title }}</span>

      <div style="float: right; margin-top: -5px">
        <el-button icon="el-icon-check" size="mini" @click="save" :disabled="btn.saveDisabled">{{
          $t('저장')
        }}</el-button>
      </div>
    </div>
    <div>
      <!-- 주문 접수 임시중단(R-E1) — 저장 버튼과 무관하게 즉시 반영된다(폼 밖). 등록 폼(storeCd 없음)에는 없다 -->
      <StorePauseCard
        v-if="inputForm.storeCd"
        :store-cd="inputForm.storeCd"
        :paused-until.sync="inputForm.pausedUntil" />
      <el-form
        :model="inputForm"
        label-width="180px"
        label-suffix=":"
        :size="size"
        @submit.native.prevent
        :label-position="$device.mobile ? `top` : ``">
        <!-- 매장 폼의 탭은 세 화면이 같은 컴포넌트로 그린다(`StoreFormTabs`) — 이 화면의 묶음·TV 쿠폰 탭만 뒤에 붙인다 -->
        <StoreFormTabs
          v-model="activiTabStore"
          :form="inputForm"
          :formError="formError"
          :deliveryAgencyOptions="deliveryAgencyOptions"
          :brandCodeOptionsMap="brandCodeOptionsMap"
          :custSearch="custSearch"
          :cust="cust"
          @addDeliveryFee="addDeliveryFee"
          @removeDeliveryFee="removeDeliveryFee"
          @addDeliveryAgency="addDeliveryAgency"
          @removeDeliveryAgency="removeDeliveryAgency">
          <el-tab-pane
            v-if="checkAuthActionAccess('ShopInShopView') && inputForm.storeCd"
            :label="$t('매장 묶음')"
            name="shopInShop"
            lazy>
            <ShopInShopPanel
              :store-cd="inputForm.storeCd"
              :editable="checkAuthActionAccess('ShopInShopEdit')"
              :attributes-editable="checkAuthActionAccess('StoreGroupAttributesEdit')" />
          </el-tab-pane>
          <!-- 우리동네TV 쿠폰(R-C) — 목록 액션이 있는 세션에만, 등록 폼(storeCd 없음)에는 없다. 처음 열 때 읽는다(lazy) -->
          <el-tab-pane
            v-if="checkAuthActionAccess(tvCouponListAction) && inputForm.storeCd"
            :label="$t(tvCouponTabTitle)"
            name="tvCoupon"
            lazy>
            <TvCouponPanel :storeCd="inputForm.storeCd" />
          </el-tab-pane>
        </StoreFormTabs>
      </el-form>
    </div>
  </el-card>
</template>

<script>
import StoreFormTabs from '@/components/store/StoreFormTabs.vue'
import StorePauseCard from '@/components/store/StorePauseCard.vue'
import ShopInShopPanel from '@/components/store/ShopInShopPanel.vue'
import TvCouponPanel from '@/components/store/TvCouponPanel.vue'
import { mapGetters } from 'vuex'
import { util } from '@/mixins/utilMixin'
import { storeFormMixin } from '@/mixins/storeFormMixin'
import { checkAuthActionAccess } from '@/utils/checkAuthActionAccess'
import { TV_COUPON_ACTION, TV_COUPON_TEXT } from '@/utils/tvCoupon'

export default {
  mixins: [storeFormMixin],
  props: ['btn', 'selectedStoreCd', 'custSearch', 'cust', 'search'],

  components: {
    StoreFormTabs,
    StorePauseCard,
    ShopInShopPanel,
    TvCouponPanel,
  },

  data() {
    return {
      size: 'small',
      activiTabStore: 'info',

      // 트리에 아무것도 고르지 않은 처음 상태는 **빈 등록 폼**이다(`statu` 는 이 자리가 소유한다)
      inputForm: this.initInputForm({ statu: 'I' }),
      formError: this.initFormError(),

      /** 우리동네TV 쿠폰 탭 — 목록 액션이 있는 세션에만 그린다(없으면 요청이 403 = 로그아웃이다) */
      tvCouponListAction: TV_COUPON_ACTION.LIST,
      tvCouponTabTitle: TV_COUPON_TEXT.tabTitle,
    }
  },

  computed: {
    ...mapGetters({
      inputHeight: 'ui/inputHeight',
    }),
    /**
     * **소속 사업장 칸을 그리는 유일한 폼** — 그래서 관리자 매장 엔드포인트의 본문 `cust` 계약을 만족한다
     * (믹스인 기본은 거짓이고, 액션 보유가 그 위에서 한 번 더 좁힌다).
     */
    usesMngStoreEndpoint() {
      return true
    },
  },

  watch: {
    'inputFormCust.startDt': function (newVal) {
      if (!util.isEmpty(this.inputFormCust.startDt) && !util.isEmpty(this.inputFormCust.endDt)) {
        if (this.inputFormCust.startDt > this.inputFormCust.endDt) {
          this.formErrorCust.startDt = this.$t('가입일은 탈퇴일 이전의 일자만 설정 가능 합니다.')
          this.inputFormCust.startDt = this.inputFormCust.endDt
          this.formErrorCust.endDt = ''
        }
      }
    },
    'inputFormCust.endDt': function (newVal) {
      if (!util.isEmpty(this.inputFormCust.startDt) && !util.isEmpty(this.inputFormCust.endDt)) {
        if (this.inputFormCust.startDt > this.inputFormCust.endDt) {
          this.formErrorCust.endDt = this.$t('탈퇴일은 가입일 이후의 일자만 설정 가능 합니다.')
          this.formErrorCust.startDt = ''
          this.inputFormCust.endDt = this.inputFormCust.startDt
        }
      }
    },
    'inputForm.startDt': function (newVal) {
      if (!util.isEmpty(this.inputForm.startDt) && !util.isEmpty(this.inputForm.endDt)) {
        if (this.inputForm.startDt > this.inputForm.endDt) {
          this.formError.startDt = this.$t('가입일은 탈퇴일 이전의 일자만 설정 가능 합니다.')
          this.inputForm.startDt = this.inputForm.endDt
          this.formError.endDt = ''
        }
      }
    },
    'inputForm.endDt': function (newVal) {
      if (!util.isEmpty(this.inputForm.startDt) && !util.isEmpty(this.inputForm.endDt)) {
        if (this.inputForm.startDt > this.inputForm.endDt) {
          this.formError.endDt = this.$t('탈퇴일은 가입일 이후의 일자만 설정 가능 합니다.')
          this.formError.startDt = ''
          this.inputForm.endDt = this.inputForm.startDt
        }
      }
    },

    /**
     * 고른 매장이 없어지면 **빈 등록 폼**으로 돌아간다. 조회는 여기서 하지 않는다 — 부모가 매 클릭마다
     * [loadStore] 를 부른다. 값이 같으면 watcher 가 돌지 않아, 같은 매장을 다시 누를 때 잠금이 풀리지
     * 않는 결함이 있었다(저장이 영구히 잠긴다).
     */
    selectedStoreCd: {
      immediate: true,
      handler(val) {
        if (!val) this.inputForm = this.initInputForm({ statu: 'I' })
      },
    },
  },

  mounted() {
    this.initLan()
    this.initPayTp()
    this.initMenuShowTp()
  },

  methods: {
    /** 세션 액션 판정 — 이 화면은 `mainVueMixin` 을 쓰지 않으므로 같은 함수를 직접 둔다 */
    checkAuthActionAccess,

    /**
     * **매장 하나를 읽어 폼에 채운다** — 부모가 매장 노드를 누를 때마다 부른다(같은 매장이어도).
     *
     * 잠금·조회·해제·실패 안내·순번 가드는 믹스인의 `loadStoreDetail` 한 곳이 갖고, 이 화면은
     * 제목(매장명)과 첫 언어 탭만 정한다.
     */
    loadStore(storeCd) {
      if (!storeCd) return

      return this.loadStoreDetail({
        url: '/store/' + storeCd,
        onLoaded: function (form) {
          if (form.lans && form.lans.length > 0) this.activiTab = form.lans[0].id

          this.activiTabStore = 'info'
        }.bind(this),
      })
    },

    /** `btn` 은 부모가 넘긴 객체다 — 직접 바꾸지 않고 알린다(`vue/no-mutating-props`) */
    setSaveLocked(locked) {
      this.$emit('save-lock', locked)
    },

    /**
     * 저장 성공 뒤 — 이 화면은 다이얼로그도 `mainVueMixin` 도 없고(`this.mainVue` 가 없다),
     * `search` 는 부모 `CustTreeView` 가 넘긴 함수다. 트리를 다시 읽어 새 매장·바뀐 이름을 반영한다.
     *
     * **등록은 폼을 비운다.** 등록 뒤에도 폼이 `statu='I'` 로 남으면 한 번 더 누를 때 같은 내용의 매장과
     * 매장 관리자 계정이 하나 더 생긴다(서버 `addMng` 는 중복을 막지 않는다). 방금 고른 사업장은 그대로
     * 두어 같은 사업장에 매장을 이어 등록할 수 있게 한다.
     */
    onStoreSaved({ method }) {
      this.$message({ type: 'success', message: this.$t('add' === method ? '등록 성공' : '수정 성공') })

      if ('add' === method) this.onAddNewStore(this.inputForm.cust)

      this.search()
    },

    onAddNewStore(cust) {
      // 상세를 읽는 중이면 그 응답을 버린다 — 늦게 오면 이 등록 폼을 수정 폼으로 덮는다
      this.cancelStoreDetail()

      this.inputForm = this.initInputForm({ statu: 'I' })

      if (cust) {
        this.inputForm.cust = cust
      }

      this.inputForm.title = this.$t('매장 추가')
      this.inputForm.lans = []
      this.inputForm.storeInfos = []
      this.formError = this.initFormError()

      this.imgList = []

      if (null != this.lans && this.lans.length > 0) {
        for (var i = 0, len = this.lans.length; i < len; i++) {
          if (this.lans[i].default_) {
            this.inputForm.defaultLan.id = this.lans[i].id
          }
        }
      }

      for (var i = 0, len = this.inputForm.storeTimesDetail.length; i < len; i++) {
        this.formError['storeTimesDetail[' + i + '].tm'] = ''
        this.formError['storeTimesDetail[' + i + '].btm'] = ''
      }

      for (var i = 0, len = this.inputForm.storeTimesSimple.length; i < len; i++) {
        this.formError['storeTimesSimple[' + i + '].tm'] = ''
        this.formError['storeTimesSimple[' + i + '].btm'] = ''
      }
    },
  },
}
</script>
